import { render, staticRenderFns } from "./ContactsTable.vue?vue&type=template&id=4dc77e47"
import script from "./ContactsTable.vue?vue&type=script&lang=js"
export * from "./ContactsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports